import styled from 'styled-components';
import { Row, Tag, Button } from 'antd';
import CustomCard from '@components/CustomCard';

export const CardContainer = styled(CustomCard)`
  .card-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.text};

    .card-title-box {
      display: flex;
      gap: 0.1rem;
      align-items: center;

      .card-title {
        font-weight: 600;
        font-size: 1.1rem;
      }

      .filters-button {
        margin-left: 1rem;
      }
    }

    .anticon-question-circle {
      svg {
        width: 1.2rem;
        height: 1.2rem;
        fill: ${({ theme }) => theme.colors?.text};
      }
    }

    .ant-tabs {
      padding: 0;
    }

    .ant-tabs-tab {
      margin: 0;

      .ant-tabs-ink-bar {
        padding: 20px;
      }
    }

    .ant-radio-group {
      z-index: 0;
    }

    .ant-radio-button-wrapper {
      margin: 0;
      flex-wrap: wrap;

      span {
        font-weight: normal;
      }
    }

    @media (max-width: 500px) {
      justify-content: center;

      .ant-radio-group {
        margin-top: 16px;
      }
    }
  }

  .ant-card-body {
    padding: 16px;
  }

  [data-chart-source-type='G2Plot'] {
    > div {
      z-index: 0;
    }
  }

  .g2-html-annotation {
    opacity: 0.8;
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  .g2-html-annotation + .g2-html-annotation {
    margin-top: 8px !important;
    font-size: 1.8rem !important;
    color: ${({ theme }) => theme.colors.text} !important;
  }
`;

export const ContainerRow = styled(Row)`
  margin-bottom: 16px;

  div.ant-typography {
    margin: 0;
    width: fit-content;
  }

  .ant-statistic-content {
    overflow: hidden;
  }
  .ant-badge {
    height: 100%;
    .ant-badge-status-dot {
      width: 14px;
      height: 14px;
    }
  }

  article {
    color: black !important;
    font-size: 4.5rem;
    background: white;
    text-align: center;
    font-weight: 600;
    line-height: 200px;

    @media (max-width: 1650px) {
      font-size: 3rem;
      line-height: 150px;
    }

    @media (max-width: 800px) {
      font-size: 2rem;
      line-height: 100px;
    }

    @media (max-width: 500px) {
      font-size: 1.5rem;
      line-height: 50px;
    }
  }

  .custom-tooltip {
    text-align: center;
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    padding: 12px;
  }
  .g2-tooltip-title {
    margin-top: 12px !important;
  }

  h1 {
    color: black !important;
    font-size: 1rem;
    background: white;
    text-align: center;
    font-weight: 600;
    margin: 0;
    height: 40px;
    padding: 16px 4px 0;

    @media (max-width: 500px) {
      font-size: 0.8rem;
    }

    @media (max-width: 400px) {
      font-size: 0.6rem;
      padding-top: 8px;
    }
  }
`;

export const FiltersContainer = styled.div`
  div {
    margin: 0;
  }
`;

export const LegendContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
  padding: 8px;
  margin-bottom: 16px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const LegendTag = styled(Tag)<{
  $isVisible: boolean;
  $color: string;
}>`
  cursor: pointer;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0.5)};
  border: 1px solid ${({ $color }) => $color};
  background-color: ${({ $isVisible, $color }) =>
    $isVisible ? $color : 'transparent'};
  color: ${({ $isVisible, $color }) => ($isVisible ? '#fff' : $color)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  text-align: center;

  &:hover {
    opacity: 0.8;
  }
`;

export const LegendButton = styled(Button)<{
  $color: string;
  $isVisible: boolean;
}>`
  padding: 0 4px;
  height: 20px;
  min-width: 20px;
  font-size: 10px;
  color: ${({ $color }) => $color};
  border: 1px solid ${({ $color }) => $color};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0.5)};

  &:hover {
    color: ${({ $color }) => $color};
    border-color: ${({ $color }) => $color};
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.2s ease;
  }

  &:focus {
    color: ${({ $color }) => $color};
    border-color: ${({ $color }) => $color};
  }

  /* Estilo especial para o ícone de isolamento */
  .anticon-pushpin {
    color: ${({ $color }) => $color};
    font-weight: bold;
  }

  /* Destaque quando está isolado */
  &:has(.anticon-pushpin) {
    background-color: ${({ $color }) => `${$color}15`};
    box-shadow: 0 0 4px ${({ $color }) => `${$color}50`};
  }
`;
